import React from 'react'
import UnderConstruction from '../misc/temp/UnderConstruction'
import Completion from '../misc/temp/Completion'

const Blog = () => {
  return (
    <>
      
      <Completion percentage="14" status="building ui layout"/>
      <UnderConstruction name="Blog Section"/>
    </>
  )
}

export default Blog